export default "__VITE_ASSET__Wp2Ordot__"